"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Constants = /** @class */ (function () {
    function Constants() {
    }
    // FILTER
    Constants.FILTER_PREFIX_TAG = 'TAG_';
    Constants.FILTER_PREFIX_ROG = 'ROG_';
    Constants.FILTER_PREFIX_QUESTIONTEMPLATE = 'QUESTIONTEMPLATE_';
    Constants.FILTER_PREFIX_LANGUAGE = 'LANG_';
    Constants.FILTER_PREFIX_BENCHMARK = 'BENCHMARK_';
    Constants.customHtmlEditorOptions = {
        options: ['inline', 'list', 'textAlign', 'fontSize', 'fontFamily', 'remove', 'history', 'colorPicker', 'link'],
        inline: {
            inDropdown: false,
            options: ['bold', 'italic', 'underline'],
        },
        list: {
            inDropdown: false,
            options: ['unordered', 'ordered', 'indent', 'outdent'],
        },
        textAlign: {
            inDropdown: false,
            options: ['left', 'center', 'right', 'justify'],
        },
        fontFamily: {
            inDropdown: true,
            options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana'],
        },
        fontSize: {
            inDropdown: true,
            options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
        },
        history: {
            inDropdown: false,
            options: ['undo', 'redo'],
        },
    };
    // CUSTOM QUESTIONS
    Constants.CUSTOMQUESTION_RESPONSEOPTIONGROUP_CODES = [
        '1',
        '16',
        '19',
        '25',
        '20',
        '17',
        '21',
        '18',
        '22',
        '23',
        '24',
        '10',
        '2',
    ];
    // DEFAULT CULTURE CODE
    Constants.DEFAULT_CULTURE_CODE = 'en-US';
    Constants.DEFAULT_CULTURE_NAME = 'English (United States)';
    Constants.DEFAULT_CULTURE_ID = 60;
    Constants.RESPONSE_OPTION_GROUP_TAB_STANDARD = 'Standard';
    Constants.RESPONSE_OPTION_GROUP_TAB_CUSTOM = 'Custom';
    return Constants;
}());
exports.default = Constants;
